class CreateOwnSet extends HTMLElement {
    constructor() {
        super();
    
        this.checkboxes = this.querySelectorAll(
            '.create-own-set__product input[type="checkbox"]'
        );
        this.savedItemsDiv = document.querySelector("[data-set-value]");
        this.savedProductItems = this.querySelectorAll(".saved_item-select");
        this.currentCount = document.querySelector("[data-current-count]");
        this.addBtn = document.querySelector("[data-add-set]"); 
        this.getCheckedItems();
        this.handleAddSetToCart();
    }
  
    getCheckedItems() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
            const productHandle = checkbox.value;
            // const productName =
            //   checkbox.parentElement.querySelector("label").textContent;
            const productName = checkbox.dataset.title;
            const productB = checkbox.closest(".create-own-set__details");
            const clonedElement = productB.cloneNode(true);
    
            if (checkbox.checked) {
                this.addToSavedItems(
                productHandle,
                productName,
                clonedElement,
                checkbox
                );
            } else {
                this.removeFromSavedItems(
                productHandle,
                productName,
                clonedElement,
                checkbox
                );
            }
            });
        });
    }
  
    addToSavedItems(handle, name, cloned, checkbox) {

        let countSaved = parseInt(
            this.savedItemsDiv.value
        );
    
        if (countSaved <= 5) {
            this.savedItemsDiv.value = countSaved + 1;
            let UpdatedCount = parseInt(
            this.savedItemsDiv.value
            );
    
            checkbox
            .closest(".create-own-set__details")
            .querySelector(".number").innerHTML = UpdatedCount;
    
            this.currentCount.innerHTML = UpdatedCount;

    
            const savedItem = document.createElement("div");
            savedItem.classList.add("saved-item");
            savedItem.setAttribute("data-handle", handle);
    
            for (const checkbox of this.savedProductItems) {
                if (!checkbox.classList.contains("active")) {

                    checkbox.classList.add("active");
                    checkbox.setAttribute("data-handle", handle);
                    checkbox.setAttribute("data-title", name);
                    break; // This will exit the loop
                }
            }
    
            UpdatedCount == 6? this.addBtn.removeAttribute("disabled"):this.addBtn.setAttribute("disabled","disabled")
            
        } else {
            alert("You can only select 6 perfumes");
            checkbox.checked = false;
            return;
        }
    }
  
    removeFromSavedItems(handle, name, cloned, checkbox) {
        let countSaved = parseInt(
            this.savedItemsDiv.value
        );
        this.savedItemsDiv.value = countSaved - 1;
        let UpdatedCount = parseInt(
            this.savedItemsDiv.value
        );
    
        checkbox
            .closest(".create-own-set__details")
            .querySelector(".number").innerHTML = UpdatedCount;
        let checkedCheckbox = null;
    
        this.currentCount.innerHTML = UpdatedCount;
      
    
        UpdatedCount == 6?this.addBtn.removeAttribute("disabled"):this.addBtn.setAttribute("disabled","disabled");
       
    
        const itemToRemove = document.querySelector(
            `.saved_items [data-handle="${handle}"]`
        );
        
        if (itemToRemove) {
            itemToRemove.classList.remove("active");
            itemToRemove.removeAttribute("data-handle");
            itemToRemove.removeAttribute("data-title");
        }
    
        let checkedCheckboxIndex = 0;
        this.checkboxes.forEach((checkbox, index) => {
            if (checkbox.checked) {
            checkedCheckboxIndex++;
            checkbox
                .closest(".create-own-set__details")
                .querySelector(".number").innerHTML = checkedCheckboxIndex;
            }
        });
    }

    normalizeBundleOptionTitle(title) {
        return String(title || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .replace(/\b\d+\s*ml\b/g, "")
            .replace(/[^a-z0-9]+/g, "");
    }

    formatBundleOptionValue(title) {
        const baseTitle = String(title || "")
            .trim()
            .replace(/\s*-\s*2\s*ml\s*-\s*2\s*ml\s*$/i, "")
            .replace(/\s+2\s*ml\s*-\s*2\s*ml\s*$/i, "")
            .replace(/\s*-\s*2\s*ml\s*$/i, "")
            .replace(/\s+2\s*ml\s*$/i, "")
            .trim();

        return baseTitle ? `${baseTitle} - 2 ML` : "";
    }

    getSimpleBundlesOptionValues() {
        const optionValues = [];
        const addOptionValue = (value) => {
            const trimmedValue = String(value || "").trim();

            if (trimmedValue && !optionValues.includes(trimmedValue)) {
                optionValues.push(trimmedValue);
            }
        };
        const addOptionValues = (values) => {
            String(values || "")
                .split(",")
                .forEach(addOptionValue);
        };

        document
            .querySelectorAll('#simple-bundles-io-options select option[value]:not([disabled])')
            .forEach((option) => addOptionValue(option.value));

        const bundleVariantId = document.querySelector("#bundle-variation-id")?.value;
        const simpleBundlesVariant = window.SimpleBundles?.productVariants?.[bundleVariantId];

        simpleBundlesVariant?.variant_options?.forEach((option) => {
            addOptionValues(option.optionValues);
        });
        (simpleBundlesVariant?.variant_options_v2?.flat?.(2) || []).forEach((option) => {
            addOptionValues(option.optionValues);
        });

        return optionValues;
    }

    getSimpleBundlesOptionValue(title) {
        const normalizedTitle = this.normalizeBundleOptionTitle(title);
        const fallbackValue = this.formatBundleOptionValue(title);
        const normalizedFallbackValue = this.normalizeBundleOptionTitle(fallbackValue);
        const options = this.getSimpleBundlesOptionValues();

        for (const option of options) {
            const normalizedOptionValue = this.normalizeBundleOptionTitle(option);

            if (
                normalizedOptionValue === normalizedTitle ||
                normalizedOptionValue === normalizedFallbackValue
            ) {
                return option;
            }
        }

        if (options.length > 0) {
            return "";
        }

        return fallbackValue;
    }

    handleAddSetToCart() {
        let addToCartButton = this.addBtn;
        // Add a click event listener to the button
        if (addToCartButton) {
          addToCartButton.addEventListener("click", async (e) => {
            e.preventDefault();
            let savedItems = this.querySelectorAll(".saved_item-select.active");
            
            let checkedItems = this.querySelectorAll(
              '.create-own-set__product input[type="checkbox"]:checked'
            );
            if (savedItems.length !== 6 || checkedItems.length !== 6) {
              alert("Please select 6 samples before adding to cart.");
              return; 
            }
            this.addBtn.disabled = true;
            // let productData = [];
            let propertiesData = {};
            let bundleSelectionArray = [];
  
            savedItems.forEach((item, idx) => {
              let title = item.getAttribute("data-title");
              
             let optionName = (item.getAttribute("data-bundle-option-name") || `Product ${idx + 1}`).trim();
             
          
        
              let bundleOptionValue = this.getSimpleBundlesOptionValue(title);

              propertiesData[optionName] = bundleOptionValue;
              bundleSelectionArray.push(bundleOptionValue);
            });

            const validBundleSelections = bundleSelectionArray.filter(Boolean);
            if (validBundleSelections.length !== 6) {
              alert("Please select 6 samples before adding to cart.");
              this.addBtn.disabled = false;
              return;
            }
  
            const bundleVariantId = +document.querySelector(
              "#bundle-variation-id"
            ).value;
            const bundleProductId =
              +document.querySelector("#bundle-product-id").value;
  
            // Concatenate bundle selection titles in the required format
            let bundleSelectionString = bundleSelectionArray.join(" <> ");
            propertiesData["_bundle_selection"] = bundleSelectionString;
  
            const data = {
              items: [
                {
                  quantity: 1,
                  id: bundleVariantId,
                  properties: propertiesData,
                  "product-id": bundleProductId,
                },
              ],
            };
  
            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.json())
              .then((responseData) => {
                
                // Dispatch cart:change event to update cart count
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      cart: responseData,
                      baseEvent: "variant:add"
                    }
                  })
                );
                
                // Find and open the cart drawer directly
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.show();
                } else {
                  console.error("Cart drawer element not found");
                }
                
                // Also refresh the cart to ensure everything is up to date
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              })
              .catch(function (error) {
                console.error(error);
              })
              .finally(function () {
                // Any cleanup code can go here
              });
              this.addBtn.disabled = false;
          });
        }
      }
    
  
    
    
}
  
customElements.define("create-own-set", CreateOwnSet);
